export const environment = {
  ENV: 'DEV PWA',
  production: true,
  WEBSERVICES: {
    ONLINE: {
      WEB_SERVICE_URL: 'https://dev-webservices.qcanter.bai-tech.io',
      SOCKET_URL: 'https://dev-webservices.qcanter.bai-tech.io',
      AUDIO_URL_PREFIX: 'https://gabriele.no-ip.biz/node-services/qcanter-webservices/audio/',
    },
  },
  WEBSERVICES_MODE: 'ONLINE',
  LOGS: {
    CONSOLE: true,
    ERROR: true,
    STORAGE: true,
    SOCKET: true,
    NETWORK: true,
    PWA: true,
  },
  NEED_TO_FORCE_PLATFORM: false,
  PLATFORM_TO_FORCE: '',
  VERSION_CODE_WEB: 0,
  ASSISTANCE_EMAIL: 'support@bai-tech.io',
  STORAGE_NAME: '__qcanterpwadb_dev',
};
